export const CATEGORY_ACTIVATION_MAP = {
  all: null,
};
